import { emptyString } from "../../../../../constants";
import { toTestIdSlug } from "../../../../../shared";
import { BRAND_REPORT_PROGRESS_LABELS } from "../../../constants/brandReport.constants";
import ProgressCard from "./progressCard";

const ProgressCardsSection = ({ data, sectionTitle }) => {
  return (
    <div
      className="d-flex flex-column gap-3"
      data-testid={`progress-cards-section-${toTestIdSlug(sectionTitle || emptyString)}`}
    >
      <ProgressCard
        label={BRAND_REPORT_PROGRESS_LABELS.SURVEYS_OPENED}
        data={data.totalSurveyOpenedCount}
        colorClass="bar-opened"
      />
      <ProgressCard
        label={BRAND_REPORT_PROGRESS_LABELS.SURVEYS_STARTED}
        data={data.totalSurveyStartedCount}
        colorClass="bar-started"
      />
      <ProgressCard
        label={BRAND_REPORT_PROGRESS_LABELS.SURVEYS_COMPLETED}
        data={data.totalSurveyCompleteCount}
        colorClass="bar-completed"
      />
    </div>
  );
};

export default ProgressCardsSection;
